import { EffectsCommandMap } from 'dva';
import type { ChangeAction, OnPageMountAction, OnPageUnmountAction, FetchInformalExhibitInfoAction } from './types';
import { initialState } from './initialState';

export const pageEffects = {
  * onPageMount({ payload }: OnPageMountAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        exhibit_ID: payload.informExhibitID,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
      payload: {
        informExhibitID: payload.informExhibitID,
      },
    });
  },
  * onPageUnmount({}: OnPageUnmountAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...initialState,
      },
    });
  },
};
